module.exports = "/_next/static/images/CustomDestinations@3x-1160bc4450ebe7681bcf2a6f54afd580.webp";